function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M86.24 4.22C108.33 23.9 124 50.54 124 80c0 29.13-16.1 56.17-37.76 75.78M73.76 4.22C51.67 23.9 36 50.54 36 80c0 29.13 16.1 56.17 37.76 75.78M4 80h152M80 156V4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M136 32c-16.61 11.94-35.06 20-56 20-20.69 0-39.33-8.12-56-20M24 128c16.7-12.14 34.87-20 56-20 20.49 0 39.44 8.33 56 20"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80,
  r: 76
});

var SvgWorld = function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgWorld;